import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle, Check, AlertTriangle, Wrench, Phone, Mail, Calendar } from 'lucide-react';
export function BrochurePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 print:text-black" data-id="element-713">
      {/* Private Indicator */}
      <div className="bg-gray-100 border-b border-gray-200 py-2 print:bg-gray-200" data-id="element-714">
        <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-715">
          <div className="flex items-center justify-between" data-id="element-716">
            <p className="text-xs text-gray-500 font-medium tracking-wide" data-id="element-717">
              Brochure privado – uso comercial
            </p>
            <Link to="/" className="text-xs text-blue-600 hover:text-blue-700 font-medium print:hidden" data-id="element-718">
              ← Volver al sitio
            </Link>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="bg-gray-900 text-white py-16 sm:py-20 lg:py-24 print:py-12 print:bg-gray-900" data-id="element-719">
        <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-720">
          {/* Logo */}
          <div className="mb-10 sm:mb-12" data-id="element-721">
            <span className="text-3xl sm:text-4xl font-black tracking-tighter" data-id="element-722">
              FORAX<span className="text-blue-500" data-id="element-723">.</span>
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight mb-6" data-id="element-724">
            Ejecución de obras,
            <br data-id="element-725" />
            <span className="text-blue-400" data-id="element-726">sin sorpresas.</span>
          </h1>

          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mb-10 leading-relaxed" data-id="element-727">
            Construcción y habilitación de espacios comerciales y oficinas, con
            foco en control, coordinación y plazos.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 print:hidden" data-id="element-728">
            <a href="mailto:contacto@forax.cl?subject=Cotización de proyecto" className="inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 px-8 py-4 text-base font-bold text-white hover:bg-blue-700 transition-colors" data-id="element-729">
              Cotizar proyecto
              <ArrowRight className="h-5 w-5" data-id="element-730" />
            </a>
            <a href="https://wa.me/56992180727" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/10 px-8 py-4 text-base font-semibold text-white hover:bg-white/20 transition-colors" data-id="element-731">
              <MessageCircle className="h-5 w-5" data-id="element-732" />
              Contacto WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Qué hace FORAX */}
      <section className="py-12 sm:py-16 lg:py-20 print:py-10 bg-white" data-id="element-733">
        <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-734">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6" data-id="element-735">
            Qué hace FORAX
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl" data-id="element-736">
            FORAX se especializa en la ejecución de obras y habilitaciones
            comerciales y de oficinas. Nuestro foco está en planificar,
            coordinar y controlar la obra para asegurar cumplimiento de plazos,
            costos y estándar.
          </p>
        </div>
      </section>

      {/* Problemas que resolvemos */}
      <section className="py-12 sm:py-16 lg:py-20 print:py-10 bg-gray-50 print:bg-gray-100" data-id="element-737">
        <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-738">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8" data-id="element-739">
            Problemas que resolvemos
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6" data-id="element-740">
            {['Atrasos en obra', 'Falta de control en terreno', 'Subcontratos poco confiables', 'Desorden en la ejecución', 'Mala comunicación con el cliente'].map((problem, index) => <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-xl border border-gray-200 print:border-gray-300" data-id="element-741">
                <div className="flex-shrink-0 w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center print:bg-red-200" data-id="element-742">
                  <AlertTriangle className="h-4 w-4 text-red-600" data-id="element-743" />
                </div>
                <span className="text-gray-800 font-medium pt-1" data-id="element-744">
                  {problem}
                </span>
              </div>)}
          </div>
        </div>
      </section>

      {/* Cómo trabajamos */}
      <section className="py-12 sm:py-16 lg:py-20 print:py-10 bg-white" data-id="element-745">
        <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-746">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8" data-id="element-747">
            Cómo trabajamos
          </h2>
          <div className="space-y-4" data-id="element-748">
            {['Planificación clara desde el inicio', 'Coordinación de partidas y subcontratos', 'Control permanente en obra', 'Comunicación directa con el cliente', 'Entrega según lo comprometido'].map((step, index) => <div key={index} className="flex items-center gap-4 py-3 border-b border-gray-100 last:border-0" data-id="element-749">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm" data-id="element-750">
                  {index + 1}
                </div>
                <span className="text-gray-800 font-medium" data-id="element-751">{step}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* Servicios */}
      <section className="py-12 sm:py-16 lg:py-20 print:py-10 bg-gray-50 print:bg-gray-100" data-id="element-752">
        <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-753">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8" data-id="element-754">
            Servicios
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-755">
            {['Ejecución de obras', 'Habilitación comercial y oficinas', 'Pintura y terminaciones', 'Coordinación de subcontratos', 'Apoyo técnico en obra'].map((service, index) => <div key={index} className="flex items-center gap-3 bg-white p-4 rounded-xl border border-gray-200 print:border-gray-300" data-id="element-756">
                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center print:bg-blue-200" data-id="element-757">
                  <Check className="h-3.5 w-3.5 text-blue-600" data-id="element-758" />
                </div>
                <span className="text-gray-800 font-medium" data-id="element-759">{service}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* Confianza y experiencia */}
      <section className="py-12 sm:py-16 lg:py-20 print:py-10 bg-white" data-id="element-760">
        <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-761">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6" data-id="element-762">
            Confianza y experiencia
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl" data-id="element-763">
            FORAX cuenta con experiencia ejecutando proyectos de construcción y
            habilitación para clientes comerciales y profesionales, con foco en
            orden, control y cumplimiento.
          </p>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-12 sm:py-16 lg:py-20 print:py-10 bg-gray-900 text-white print:bg-gray-900" data-id="element-764">
        <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-765">
          <h2 className="text-2xl sm:text-3xl font-bold mb-8" data-id="element-766">
            ¿Tienes una obra que ejecutar?
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-767">
            {/* Contacto */}
            <div className="bg-white/10 rounded-2xl p-6 border border-white/10" data-id="element-768">
              <h3 className="text-lg font-bold mb-4 text-white" data-id="element-769">Contacto</h3>
              <div className="space-y-3" data-id="element-770">
                <p className="text-gray-300 font-medium" data-id="element-771">
                  Juan Riquelme Barros
                </p>
                <a href="tel:+56992180727" className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors" data-id="element-772">
                  <Phone className="h-4 w-4 text-blue-400" data-id="element-773" />
                  +56 9 9218 0727
                </a>
                <a href="mailto:contacto@forax.cl" className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors" data-id="element-774">
                  <Mail className="h-4 w-4 text-blue-400" data-id="element-775" />
                  contacto@forax.cl
                </a>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="bg-white/10 rounded-2xl p-6 border border-white/10" data-id="element-776">
              <h3 className="text-lg font-bold mb-4 text-white" data-id="element-777">WhatsApp</h3>
              <p className="text-gray-300 mb-4 text-sm" data-id="element-778">
                Escríbenos directamente para una respuesta rápida.
              </p>
              <a href="https://wa.me/56992180727" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold px-5 py-2.5 rounded-full transition-colors print:hidden" data-id="element-779">
                <MessageCircle className="h-4 w-4" data-id="element-780" />
                Abrir WhatsApp
              </a>
            </div>

            {/* Agendar */}
            <div className="bg-white/10 rounded-2xl p-6 border border-white/10" data-id="element-781">
              <h3 className="text-lg font-bold mb-4 text-white" data-id="element-782">
                Agendar reunión
              </h3>
              <p className="text-gray-300 mb-4 text-sm" data-id="element-783">
                Reserva 30 minutos para conversar tu proyecto.
              </p>
              <a href="https://calendly.com/jrb-forax/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-5 py-2.5 rounded-full transition-colors print:hidden" data-id="element-784">
                <Calendar className="h-4 w-4" data-id="element-785" />
                Agendar ahora
              </a>
            </div>
          </div>

          {/* Footer branding */}
          <div className="pt-8 border-t border-white/10" data-id="element-786">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-id="element-787">
              <span className="text-2xl font-black tracking-tighter" data-id="element-788">
                FORAX<span className="text-blue-500" data-id="element-789">.</span>
              </span>
              <p className="text-gray-500 text-sm" data-id="element-790">
                © {new Date().getFullYear()} FORAX Construcción
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Print styles indicator */}
      <style data-id="element-791">{`
        @media print {
          @page {
            size: A4;
            margin: 1cm;
          }
          body {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .print\\:hidden {
            display: none !important;
          }
        }
      `}</style>
    </div>;
}